import React from 'react'
import { graphql, useFragment } from 'react-relay'

import { buildSocialLinks, SocialProfileLinksRow } from './SocialProfileLinks'

import { GuildSocialProfileLinks_guild$key } from './__generated__/GuildSocialProfileLinks_guild.graphql'

export const GuildSocialProfileLinks = ({
  guild,
  size = '$4',
}: {
  guild: GuildSocialProfileLinks_guild$key
  size?: '$4' | '$5'
}) => {
  const data = useFragment(
    graphql`
      fragment GuildSocialProfileLinks_guild on Guild {
        websiteUrl
        twitterUrl
        instagramUrl
        linkedinUrl
        youtubeUrl
        githubUrl
        blueskyUrl
        blueskyIdentifier
      }
    `,
    guild
  )

  return <SocialProfileLinksRow links={buildSocialLinks(data)} size={size} />
}
